import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import footerLinks from "@/data/footerLinks"
import { getTranslate } from "@/tolgee/server"
import Image from "next/image"

export async function Footer() {
  const t = await getTranslate()
  return (
    <footer className="bg-primary -mx-6 xl:-mx-8 2xl:-mx-[120px]">
      <div className="max-w-[1920px] mx-auto w-full lg:px-6 xl:px-8 2xl:px-[120px]">
      <div className="grid grid-cols-1 lg:grid-cols-3">

        {/* About Column */}
        <div className="p-6 border rounded-sm">
          <h2 className="heading-sm text-primary mb-3 uppercase">
            {t("footer.about")}
          </h2>
          <nav
            className="space-y-3"
            aria-label={t("footer.about_navigation")}
          >
            {footerLinks.about.map(({ label, path }) => (
              <LocalizedClientLink
                key={label}
                href={path}
                className="block label-md"
              >
                {t(label)}
              </LocalizedClientLink>
            ))}
          </nav>
        </div>

        {/* Customer Services Column */}
        <div className="p-6 border rounded-sm">
          <h2 className="heading-sm text-primary mb-3 uppercase">
            {/* {t("footer.customer_services")} */}
            {t("footer.policy_page")}
          </h2>
          <nav
            className="space-y-3"
            aria-label={t("footer.customer_services_navigation")}
          >
            {footerLinks.customerServices.map(({ label, path }) => (
              <LocalizedClientLink
                key={label}
                href={path}
                className="block label-md"
              >
                {t(label)}
              </LocalizedClientLink>
            ))}
          </nav>
        </div>


        {/* Connect Column */}
        <div className="p-6 border rounded-sm">
          <h2 className="heading-sm text-primary mb-3 uppercase">
            {t("footer.connect")}
          </h2>
          <nav
            className="space-y-3"
            aria-label={t("footer.social_media_navigation")}
          >
            {footerLinks.connect.map(({ label, path }) => (
              <LocalizedClientLink
                key={label}
                href={path}
                className="block label-md"
                rel="noopener noreferrer"
              >
                {t(label)}
              </LocalizedClientLink>
            ))}
          </nav>


          <h2 className="heading-sm text-primary mb-3 mt-4 uppercase">{t("footer.payment_method")}</h2>
          <div className="flex gap-2 *:border-2 *:rounded-sm">
            <Image width={50} height={50} src="/fbe/paypal.png" alt=""></Image>
            <Image width={50} height={50} src="/fbe/stripe.png" alt=""></Image>
            <Image width={50} height={50} src="/fbe/visa.png" alt=""></Image>
          </div>
        </div>
      </div>

      <div className="py-6 border rounded-sm">
        <p className="text-md text-secondary text-center">
          © {new Date().getFullYear()} {t("footer.copyright")}
        </p>
      </div>
      </div>
    </footer>
  );
}